import { configureStore } from "@reduxjs/toolkit";
import LoginAuth from "./LoginAuth";
import MobileLogin from "./MobileLogin";
import NachStore from "./NachStore";
import Branch from "./Branch";
import storage from "redux-persist/lib/storage";
import NachFilterReducer from "./NachFilterReducer";
import VerificationModalReducer from "./VerificationModalReducer";
import NachApprovalReducer from "./NachApprovalReducer";
import { persistStore, persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import NachRetrievalReducer from "./NachRetrievalReducer";
import ChequeReturnReducer from "./ChequeReturnReducer";
import MandateReturnReducer from "./MandateReturnReducer";

import JournalVoucherReducer from "./JournalVoucherReducer";
import FilePaymentReducer from "./FilePayment/FilePaymentReducer";
import FileReceiptGridReducer from "./FileReceiptGridReducer";
import FilePaymentModifyReducer from "./FilePayment/FilePaymentModifyReducer";
import FilePaymentModeReducer from "./FilePayment/FilePaymentModeReducer";
import NachMode from "./Nach/NachMode";
import AdditionalFeeReducer from "./AdditionalFee/AdditionalFeeReducer";
import ParaMeterReducer from "./ParameterMaintenance/ParaMeterReducer";
import AmortCalculationReducer from "./AmortCalculation/AmortCalculationReducer";
import PageNotFoundReducer from "./PageNotFound/PageNotFoundReducer";
import CommonShortCutReducer from "./CommonShortCutsReducer";
import SpecialAccessDetailReducer from "./SpecialAccess/SpecialAccessDetailReducer";
import BatchSettingReducer from "./BatchScheduling/BatchSettingReducer";
import RepaymentStructureFilterReducer from "./RepaymentStructureFilter/RepaymentStructureFilterReducer";
import LoanClosureReducer from "./LoanClosure/LoanClosureReducer";
import SecurityChequeReducer from "./SecurityCheque/SecurityChequeReducer";
import SettlementFigureReportReducer from "./SettlementFigureReport/SettlementFigureReportReducer";
import ReSchedulementReducer from "./ReSchedulement/ReSchedulementReducer";
import CovReducer from "./Cov/CovReducer";
import DisbursementBalanceTransferReducer from "./DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import DynamicReportReducer from "./DynamicReport/DynamicReportReducer";
import SpinnerReducer from "./spinner/SpinnerReducer";
import CommonInformationDialogReduer from "./dialog/CommonInformationDialogReduer";
import FileUploadAreaAndPreviewReducer from "./FileUploadAreaAndPreviewReducer";
import DisbursementLosCustomerDataReducer from "./DisbursementLosCustomerData/DisbursementLosCustomerDataReducer";

const persistConfig = {
  key: "branch",
  storage,
};
const persistedReducer = persistReducer(persistConfig, Branch);
const store = configureStore({
  reducer: {
    branch: persistedReducer,
    login: LoginAuth,
    mob: MobileLogin,
    nach: NachStore,
    nachFilter: NachFilterReducer,
    nachVerification: VerificationModalReducer,
    nachApproval: NachApprovalReducer,
    nachRetrieval: NachRetrievalReducer,
    chequeReturn: ChequeReturnReducer,
    mandateReturn: MandateReturnReducer,
    filePayment: FilePaymentReducer,
    journalVoucher: JournalVoucherReducer,
    fileReceiptGrid: FileReceiptGridReducer,
    filePaymentModify: FilePaymentModifyReducer,
    filePaymentMode: FilePaymentModeReducer,
    nachMode: NachMode,
    AdditionalFee: AdditionalFeeReducer,
    paraMeter: ParaMeterReducer,
    amort: AmortCalculationReducer,
    pageNotFound: PageNotFoundReducer,
    shortcut: CommonShortCutReducer,
    specialAccess: SpecialAccessDetailReducer,
    batchSetting: BatchSettingReducer,
    repaymentStructureFilter: RepaymentStructureFilterReducer,
    loanClosure: LoanClosureReducer,
    cov: CovReducer,
    securityCheque: SecurityChequeReducer,
    settlementFigureReport: SettlementFigureReportReducer,
    reSchedulement: ReSchedulementReducer,
    disbursementBalanceTransfer: DisbursementBalanceTransferReducer,
    letterGeneration: DynamicReportReducer,
    spinnerReducer: SpinnerReducer,
    commonInfoDialogReduer: CommonInformationDialogReduer,
    fileUploadAreaAndPreview: FileUploadAreaAndPreviewReducer,
    disbursementLosCustomerData: DisbursementLosCustomerDataReducer,
  },
  middleware: [thunk],
});
export const persistor = persistStore(store);
export default store;
